export default __webpack_public_path__ + "static/media/confirm_update.88bfeae1.svg";